import { FC } from 'react';

import { DomainPunycode } from '@/common/components';

import { SearchConsoleAnalyticsPagesDimension } from '@/modules/DomainsApi';

interface Props {
  value: SearchConsoleAnalyticsPagesDimension['key'];
}

export const PagesLabel: FC<Props> = ({ value }) => {
  return (
    <DomainPunycode domainName={ value }/>
  );
};
